var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 249,
    viewBox: "0 0 249 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 249,
    height: 249,
    rx: 50,
    fill: "#40B0BF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0417 74.4833C45.3583 137.583 76.9167 175.517 132.25 175.517H135.383V139.417C155.717 141.442 171.083 156.308 177.258 175.525H205.983C198.092 146.8 177.358 130.925 164.408 124.858C177.358 117.375 195.558 99.1666 199.908 74.4916H173.817C168.15 94.5166 151.367 112.717 135.383 114.442V74.4833H109.292V144.467C93.1083 140.425 72.675 120.8 71.7667 74.475H44.0417V74.4833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/VK.cca9debbc6a53cdee960183d009f04a4.svg";
export { ForwardRef as ReactComponent };